var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspaceSelfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.999,
    height: 30,
    viewBox: "0 0 29.999 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29221",
    "data-name": "Group 29221",
    transform: "translate(19621 11558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "users",
    d: "M79-773.375v-5.25a5.492,5.492,0,0,0-.82-2.93A5.468,5.468,0,0,0,76-783.594a27.836,27.836,0,0,0-5.906-2.18A25.8,25.8,0,0,0,64-786.5a25.8,25.8,0,0,0-6.094.727A27.835,27.835,0,0,0,52-783.594a5.468,5.468,0,0,0-2.18,2.039,5.492,5.492,0,0,0-.82,2.93v5.25Z",
    transform: "translate(-19670 -10754.625)",
    fill: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "users-2",
    "data-name": "users",
    d: "M62.5-785a7.222,7.222,0,0,0,5.3-2.2,7.222,7.222,0,0,0,2.2-5.3,7.222,7.222,0,0,0-2.2-5.3,7.222,7.222,0,0,0-5.3-2.2,7.222,7.222,0,0,0-5.3,2.2,7.222,7.222,0,0,0-2.2,5.3,7.222,7.222,0,0,0,2.2,5.3A7.222,7.222,0,0,0,62.5-785Z",
    transform: "translate(-19668.5 -10758)",
    fill: "#ffca8b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceSelfIcon);
export default __webpack_public_path__ + "static/media/workspace_self_icon.ae057564f7f83590300a59e5a013d41c.svg";
export { ForwardRef as ReactComponent };